/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampCategoryCampDto2 } from '../../models/camp-category-camp-dto-2';
import { CampCategoryCampShowResponse } from '../../models/camp-category-camp-show-response';

export interface PatchCampCategoryCampUpdate$Params {
  category: string;
  camp: string;
      body: CampCategoryCampDto2
}

export function patchCampCategoryCampUpdate(http: HttpClient, rootUrl: string, params: PatchCampCategoryCampUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CampCategoryCampShowResponse>> {
  const rb = new RequestBuilder(rootUrl, patchCampCategoryCampUpdate.PATH, 'patch');
  if (params) {
    rb.path('category', params.category, {});
    rb.path('camp', params.camp, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampCategoryCampShowResponse>;
    })
  );
}

patchCampCategoryCampUpdate.PATH = '/v1/category/{category}/camp/{camp}';
